let config;

export const setConfig = (lobbyConfig) => { config = lobbyConfig; };
export const getSlug = () => config.slug;
export const getTag = () => config.tag;
export default () => config;
